import { callCreateFolder } from "@knowt/syncing/hooks/folders/graphqlUtils";
import { updateFolderInFolderList } from "@knowt/syncing/hooks/folders/utils";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import dynamic from "next/dynamic";
import { v4 as uuidv4 } from "uuid";
import { useMounted } from "@/hooks/useMounted";
import { useNotePageContextSelector } from "@/components/NotePage/hooks/NotePageContext";
import LazyLoaded from "@/components/LazyLoaded";

const CreateFlashcardsOptionsPopup = dynamic(() => import("./CreateFlashcardsOptionsPopup"));
const NamingPopup = dynamic(() => import("@/components/Popup/NamingPopup"));

const Popups = () => {
    const mounted = useMounted();

    const { userId, sharingEnabled } = useCurrentUser();

    const showCreateFlashcardsOptionsPopup = useNotePageContextSelector(
        state => state.showCreateFlashcardsOptionsPopup
    );

    const folderPopupOpen = useNotePageContextSelector(state => state.folderPopupOpen);

    const setShowCreateFlashcardsOptionsPopup = useNotePageContextSelector(
        state => state.setShowCreateFlashcardsOptionsPopup
    );

    const setFolderPopupOpen = useNotePageContextSelector(state => state.setFolderPopupOpen);

    if (!mounted) {
        return null;
    }

    return (
        <>
            <LazyLoaded load={folderPopupOpen}>
                <NamingPopup
                    title={"New folder"}
                    placeholder={"Untitled folder"}
                    isOpen={folderPopupOpen}
                    onClose={() => setFolderPopupOpen(false)}
                    onConfirm={async newFolderName => {
                        const newFolder = await callCreateFolder({
                            userId,
                            folderId: uuidv4(),
                            name: newFolderName,
                            trash: false,
                            public: sharingEnabled,
                        });

                        await updateFolderInFolderList({
                            userId,
                            folder: newFolder,
                        });
                    }}
                />
            </LazyLoaded>
            <LazyLoaded load={showCreateFlashcardsOptionsPopup}>
                <CreateFlashcardsOptionsPopup
                    isOpen={showCreateFlashcardsOptionsPopup}
                    onClose={() => setShowCreateFlashcardsOptionsPopup(false)}
                />
            </LazyLoaded>
        </>
    );
};

export default Popups;
